var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"queue-box"},[_c('div',{staticClass:"infos"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t("客服繁忙，让您久等了"))+"👉 "),_c('span',{staticClass:"link",on:{"click":_vm.handleLink}},[_vm._v(" ["+_vm._s(_vm.$t("自主提交"))+"] ")]),_c('br'),_vm._v(" "+_vm._s(_vm.$t("感谢理解"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }